module.exports = __webpack_public_path__ + "static/img/c23.b17dd99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c23.png
// module id = 271
// module chunks = 0 1 2 3 4 5 6 7 8 9